/* ============================================================================
   LAH — AVISO DE CONFIGURACAO GUARDADA (sobe de baixo)
   Tema: Testes de implementacao (2.0)

   Le os registros deixados por lah-retomar.js e, em paginas de navegacao, sobe
   um aviso oferecendo continuar a montagem.

   ============================================================================
   NUNCA NO CARRINHO NEM NO CHECKOUT
   ============================================================================
   Quem esta no carrinho ja passou do ponto: ele escolheu, adicionou e agora
   decide se fecha. Oferecer ali que ele volte a montar OUTRO oculos e puxa-lo
   para tras na propria compra — e o carrinho e a tela onde mais perdemos
   gente (2.175 view_cart contra 683 begin_checkout nos ultimos 14 dias).

   O aviso de carrinho abandonado ja tinha essa regra; este nao tinha, e por
   isso aparecia la.

   ============================================================================
   AS TRES REGRAS DE APARICAO
   ============================================================================
     1. UMA VEZ POR DIA. Nao por sessao: quem entra cinco vezes num dia veria
        cinco avisos, e a quinta seria irritacao, nao ajuda.
     2. TRES SEGUNDOS DEPOIS. A contagem reinicia a cada pagina — ela mede
        tempo na pagina, nao no site.
     3. NUNCA NA PAGINA DO PRODUTO GUARDADO. La o lembrete ja vive acima do
        CTA — dois avisos da mesma coisa viram ruido.

   O marcador do dia e gravado quando o aviso APARECE, nao quando e fechado:
   se fosse no fechamento, quem ignora e navega veria de novo na pagina
   seguinte.

   UM SEGUNDO ATRAS DO AVISO DE CARRINHO (3s contra 2s): os dois dividem a cota
   diaria, e carrinho com itens esta mais perto da compra.
   ============================================================================ */

(function () {
    'use strict';

    var PREFIXO = 'lah_config_';
    var CHAVE_VISTO = 'lah_retomar_toast_dia';
    var VALIDADE_DIAS = 7;
    var ESPERA_MS = 3000;

    /* Ver a nota no topo. */
    var caminho = window.location.pathname;
    if (caminho.indexOf('/cart') === 0) return;
    if (caminho.indexOf('/checkout') === 0) return;

    function track(evento, dados) {
        try {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push(Object.assign({ event: evento }, dados || {}));
        } catch (e) { /* analytics nunca deve quebrar a venda */ }
    }

    function hoje() {
        var d = new Date();
        var m = d.getMonth() + 1;
        var dia = d.getDate();
        return d.getFullYear() + '-' + (m < 10 ? '0' + m : m) + '-' + (dia < 10 ? '0' + dia : dia);
    }

    function jaViuHoje() {
        try {
            return window.localStorage.getItem(CHAVE_VISTO) === hoje();
        } catch (e) {
            return true; /* sem storage, nao insistimos */
        }
    }

    function marcarVisto() {
        try {
            window.localStorage.setItem(CHAVE_VISTO, hoje());
        } catch (e) { /* ignora */ }
    }

    /* A configuracao mais recente entre as guardadas, ja descartando as
       vencidas e a do produto que esta na tela. */
    function melhorConfiguracao() {
        var limite = VALIDADE_DIAS * 24 * 60 * 60 * 1000;
        var caminhoAtual = window.location.pathname;
        var melhor = null;

        var chaves = [];
        try {
            for (var i = 0; i < window.localStorage.length; i++) {
                var k = window.localStorage.key(i);
                if (k && k.indexOf(PREFIXO) === 0) chaves.push(k);
            }
        } catch (e) {
            return null;
        }

        chaves.forEach(function (k) {
            var dados;

            try {
                dados = JSON.parse(window.localStorage.getItem(k));
            } catch (e) {
                return;
            }

            if (!dados || !dados.escolhas || !dados.escolhas.length) return;
            if (!dados.produto || !dados.produto.url) return;

            if (Date.now() - (dados.em || 0) > limite) {
                try { window.localStorage.removeItem(k); } catch (e) {}
                return;
            }

            /* So quem chegou ao resumo e lembrado — mesma regra do lembrete na
               pagina de produto. Quem clicou numa opcao e saiu apenas olhou. */
            if (!dados.resumo) return;

            /* Ja estamos na pagina desse produto: quem manda ali e o lembrete
               acima do CTA. */
            if (caminhoAtual.indexOf(dados.produto.url) === 0) return;

            if (!melhor || (dados.em || 0) > (melhor.em || 0)) melhor = dados;
        });

        return melhor;
    }

    function montar(dados) {
        var caixa = document.createElement('div');
        caixa.className = 'lah-toast';
        caixa.setAttribute('role', 'status');

        var nomes = dados.escolhas.map(function (e) { return e.item; }).join(' · ');
        var detalhe = dados.etapa ? 'Você parou em: ' + dados.etapa : nomes;

        var html = '';

        if (dados.produto.img) {
            html += '<img class="lah-toast__img" src="' + dados.produto.img +
                '" alt="" loading="lazy" width="46" height="46">';
        }

        html += '<span class="lah-toast__corpo">' +
            '<span class="lah-toast__titulo">' + (dados.produto.nome || 'Óculos') + ' ficou pela metade</span>' +
            '<span class="lah-toast__detalhe" title="' + nomes + '">' + detalhe + '</span>' +
            '</span>' +
            '<a class="lah-toast__btn" href="' + dados.produto.url + '" data-toast-continuar>Continuar</a>' +
            '<button type="button" class="lah-toast__close" aria-label="Fechar" data-toast-fechar>&times;</button>';

        caixa.innerHTML = html;
        document.body.appendChild(caixa);

        /* Dois quadros antes de abrir: sem isso o navegador pinta o elemento ja
           na posicao final e a animacao de subida nao acontece. */
        requestAnimationFrame(function () {
            requestAnimationFrame(function () {
                caixa.classList.add('is-open');
            });
        });

        caixa.addEventListener('click', function (event) {
            if (event.target.closest('[data-toast-continuar]')) {
                track('lens_retomado', { origem: 'aviso' });
                return; /* o link segue normalmente */
            }

            if (event.target.closest('[data-toast-fechar]')) {
                track('lens_retomar_descartado', { origem: 'aviso' });
                caixa.classList.remove('is-open');
                setTimeout(function () { caixa.remove(); }, 350);
            }
        });

        marcarVisto();
        track('lens_retomar_exibido', { origem: 'aviso' });
    }

    if (jaViuHoje()) return;

    setTimeout(function () {
        /* Conferimos de novo: o aviso de carrinho roda um segundo antes e pode
           ter ocupado o lugar do dia. */
        if (jaViuHoje()) return;

        var dados = melhorConfiguracao();
        if (dados) montar(dados);
    }, ESPERA_MS);
})();
